module.exports = __webpack_public_path__ + "./fonts/lato-light-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/lato-light-webfont.eot
// module id = 19
// module chunks = 0